module.exports = __webpack_public_path__ + "img/img-a440a8af.66874f9e.png";